<template>
    <div>
        <div id="wrap" class="box"  v-if="page_b" v-cloak>
            <div class="header">
                <span class="title">
					{{he_name}}会员合同</span>
            </div>

            <div class="small-title">
                <span style="font-weight: bold;">以下简称甲方：</span>
                <ul>
                    <li style="margin-top: 10px;">合同编号: <input type="text"  name="" disabled v-model="compact"/></li>
                    <li v-if="!is_vip" style="margin: 8px 0;">会员卡号: <input type="text" disabled v-model="vip"/></li>
                    <li v-if="is_vip" style="margin: 8px 0;">会员卡号: <input type="text"  disabled v-model="vip"/></li>
                    <li>收据编号: <input type="text" name="" disabled  v-model="dindan" value=""/></li>
                </ul>
            </div>
            <div style="position: relative;">
                <div class="infant" v-for="(item,index) in infant_arr">
                    <label class="title">幼儿{{index+1}}</label>
                    <span @click="add(index)" style="margin-left:10px;" class="add">+</span>
                    <label style="margin-left: 8px;" >姓名： </label>
                    <input type="text" disabled v-if="index == 0" @input="search_name(item.baobao_name,index)" style="width: 75px" v-model="item.baobao_name" class="n_input" name="" value=""/>
                    <input type="text" disabled v-if="index != 0" v-model="item.baobao_name" style="width: 75px" disabled  class="n_input" name="" value=""/>

                    <label >别名： </label>
                    <input type="text" v-if="index == 0"  class="n_input" disabled name="" disabled v-model="item.baobao_name2" />
                    <input type="text" v-if="index != 0"  class="n_input"  name="" disabled  v-model="item.baobao_name2" />
                    <label >性别： </label>
                    <el-radio v-model="item.baobao_sex" style="margin-left:5px;" disabled label="男" >男</el-radio>
                    <el-radio v-model="item.baobao_sex" style="margin-left:5px;" disabled label="女">女</el-radio>

                    <label >出生日期： </label>
                    <input type="text" class="n_input" disabled name=""  style="width: 120px;" v-if="index==0" v-model="item.baobao_birthday"/>
                    <!--<input type="text" class="n_input"  name=""  style="width: 80px;" v-if="index!=0" v-model="item.baobao_birthday"/>-->
                    <el-date-picker
                            v-model="item.baobao_birthday"
                            class="n_input"
                            v-if="index!=0"
                            style="padding-left: 0;width: 130px;"
                            size="mini"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                    <span @click="remove(index)" class="add" style="font-size: 18px;margin-left: 8px;">-</span>
                </div>
                <ul class="ul_list" v-show="ul_show">
                    <li v-for="item in name_list" @click="confirm_name(item.user_id)">
                        <span>{{item.baobao_name}}</span>
                        <span>{{item.baobao_name2}}</span>
                    </li>
                </ul>
            </div>

            <div class="information">
                <ul style="margin-right: 10px;">
                    <li><span style="font-weight: bold;">父亲资料：</span></li>
                    <li>
                        <span>姓 &nbsp;&nbsp;&nbsp; 名:</span> <input type="text" disabled  v-model="parent_list.name1"/>
                    </li>
                    <li>
                        <span>手机号码:</span> <input type="text" disabled maxlength="11"  v-model="parent_list.phone1"/>
                    </li>
                    <li>
                        <span>电子邮件:</span> <input type="text" disabled  v-model="parent_list.email1"/>
                    </li>
                    <li>
                        <span>地 &nbsp;&nbsp;&nbsp; 址:</span> <input type="text"  disabled  v-model="parent_list.site"/>
                    </li>
                </ul>
                <ul>
                    <li><span style="font-weight: bold;">母亲资料：</span></li>
                    <li>
                        <span>姓 &nbsp;&nbsp;&nbsp; 名:</span> <input type="text" disabled  v-model="parent_list.name2"/>
                    </li>
                    <li>
                        <span>手机号码:</span> <input type="text" disabled maxlength="11"   v-model="parent_list.phone2"/>
                    </li>
                    <li>
                        <span>电子邮件:</span> <input type="text" disabled  v-model="parent_list.email2"/>
                    </li>
                    <li>
                        <span>地 &nbsp;&nbsp;&nbsp; 址:</span> <input type="text" disabled  v-model="parent_list.site"/>
                    </li>
                </ul>
            </div>

            <div class="content">
                <div class="line" style="font-weight: bold;margin: 25px 0 18px 0;">以下简称乙方：</div>
                <div class="line">公司名称：{{centre_list.t_name}}</div>
                <div class="line">授课中心名称：{{centre_list.centre}}</div>
                <div class="line">授课中心地址：{{centre_list.site}}</div>
                <div class="line" style="line-height: 20px;margin-top: 3px;">
                    <textarea v-model="droit_e" maxlength="240" style="width: 100%;height:86px" placeholder="*请输入权利说明(限200字)"></textarea>
                </div>

                <div class="title">I. 课程及费用：</div>
                <table class="one-table" cellspacing="0" border="1">
                    <tr class="tr">
                        <td>课程组合</td>
                        <td>节数</td>
                        <td>赠送课时</td>
                        <td>售价</td>
                        <td>协议到期日</td>
                        <td>课时合计</td>
                    </tr>
                    <tr>
                        <td>
                            <select name="" v-model="s_id" @change="save_price(s_id)" disabled>
                                <option value="">请选择</option>
                                <option v-for="item in class_list" :value="item.s_id">
                                    {{item.s_name}}
                                </option>
                            </select>

                        </td>
                        <td>{{pitch}}</td>
                        <td>
                            <input type="number" disabled style="width: 50px;padding-left: 8px;" v-model="give_class" name=""
                                   min="0"/>
                        </td>
                        <td>{{f_price}}</td>
                        <td>
                            <el-date-picker
                                    v-model="value1"
                                    size="mini"
                                    type="date"
									disabled
                                    placeholder="选择日期">
                            </el-date-picker>
                        </td>
                        <td>{{total}}</td>
                    </tr>
                </table>
				<div style="padding-top: 10px;">
					是否赠送其他项目<span style="padding-left: 20px;"></span>
					 <input disabled style="display: inline-block;vertical-align: middle;margin-bottom: 2px; " type="checkbox" @click="ckbox_but($event)"/>
					 {{ckbox_name}}
				</div>
                <label class="title">II. 优惠券选择：</label>
                <select class="sel" name="" v-model="y_id" @change="youhui(y_id)" disabled>
                    <option value="">请选择</option>
                    <option v-for="item in y_list" :value="item.s_id">{{item.s_name}}</option>
                </select>
                <div class="title">III. 付款安排：</div>
                <table class="two-table" cellspacing="0" border="1">
                    <tr>
                        <td style="width: 50%;">
                            <div>应 &nbsp;&nbsp;&nbsp;&nbsp; 付 &nbsp;&nbsp; ￥ <span>{{f_price}}</span></div>
                            <div>实 &nbsp;&nbsp;&nbsp;&nbsp; 收 &nbsp;&nbsp; ￥ <input type="text" class="s_pinput" style="width:80px;" disabled v-model="s_price"/></div>
                            <div>优 &nbsp;&nbsp;&nbsp;&nbsp; 惠 &nbsp;&nbsp; ￥ <span>{{y_price}}</span></div>
                        </td>
                        <td style="position: relative;">
                            <span style="position: absolute;top: 10px;left: 10px;" >备注：</span>
                            <textarea disabled placeholder="请输入..." v-model="bz" rows="" cols=""></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                                <span>付款方式 &nbsp;&nbsp; :</span>
                                <select style="margin: 0 0 0 10px;" class="sel" v-model="receipt_type" disabled>
                                    <option value="">请选择</option>
                                    <option v-for="item in pay_list" :value="item.name">{{item.name}}</option>
                                </select>
                            </div>
                            <div>
                                <span>付款日期 &nbsp;&nbsp; :</span>
                                <el-date-picker
                                        style="padding: 0;border-top: 0;margin-left: 10px;"
                                        v-model="value2"
                                        size="mini"
                                        type="date"
										disabled
                                        placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </td>
                        <td style="position: relative;">
					<span style="position: absolute;top: 10px;left: 10px;">礼物:
						<button  disabled>请选择</button>
					</span>

                          <span v-for="(item,index) in goods" class="close_btn">
                    	{{item.g_name}}x{{item.g_limit}}
                    	<span @click="del_gift(index)" style="color:red;padding-right: 3px;">x</span>
                    </span>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 10px;" colspan="2">
                            *说明：
                            <div style="padding:8px 0 0;line-height: 18px;">
                                <textarea
								style="margin-top:0;margin-left: 0;width: 100%;height: 86px;"
								v-model="payment_e"
								maxlength="240"
								placeholder="请输入请假说明或者其他注意事项(限200字)">
								</textarea>
                            </div>
                        </td>
                    </tr>
                </table>


                <div class="title">IV. 签署：(以下栏目需手签)</div>
                <div class="information" style="margin-left: 0;">
                    <ul style="margin-right: 10px;">
                        <li>
                            <span>甲 &nbsp;&nbsp;&nbsp; 方:</span>
                            <!--<span style="letter-spacing: 0;">本人声明已阅读并接受本合同及合同背页所列条款。</span>-->
                            <span style="letter-spacing: 0;"></span>
                        </li>
                        <li>
                            <span>签 &nbsp;&nbsp;&nbsp; 署:</span> <input type="text" name="" disabled   value=""/>
                        </li>
                        <li>
                            <span>日 &nbsp;&nbsp;&nbsp; 期:</span> <input type="text" name="" disabled  value=""/>
                        </li>
                        <li>
                            <span style="margin-left: 2px;">付&nbsp;款&nbsp;人:</span> <input type="text" disabled name=""  value=""/>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <span>乙 &nbsp;&nbsp;&nbsp; 方:</span>
                            <span style="float: right;margin-right: 6px;">(盖章有效)</span>
                        </li>
                        <li>
                            <span>签 &nbsp;&nbsp;&nbsp; 署:</span> <input type="text" name="" disabled name=""   value=""/>
                        </li>
                        <li>
                            <span>日 &nbsp;&nbsp;&nbsp; 期:</span> <input type="text" name="" disabled name=""  value=""/>
                        </li>
                        <li>
                            <span style="margin-left: 2px;">收&nbsp;据&nbsp;号:</span> <input type="text" disabled name=""  name=""  value=""/>
                        </li>
                    </ul>
                </div>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisibl2"
                        width="20%">
                    <div style="padding:10px;">签约完成,请确认操作</div>
                    <span slot="footer" class="dialog-footer">
                <a href="{:U('User/index')}" style="padding: 4px 8px;font-size: 12px;" class="btn btn-default">会员列表</a>
                <el-button type="success" @click="jump()">打印合同</el-button>
                </span>
                </el-dialog>

            </div>
            <div style="margin: 20px;display:block">
                <el-button v-if="check_mull==2" style="font-size: 18px;margin-left: 280px;" @click="add_a" >添加</el-button>
                <el-button v-if="check_mull==1" style="font-size: 18px;margin-left: 280px;" @click="add_a" >查看背面条款</el-button>
            </div>
        </div>
         <div class="back_box" v-if="!page_b">
			<textarea v-model="clause_name" placeholder="*请输入条款协议"></textarea>
			<div style="margin: 20px;display:block">
			     <el-button v-if="check_mull==2" style="font-size: 18px;margin-left: 280px;" @click="add_con" >确认</el-button>
			     <el-button v-if="check_mull==1" style="font-size: 18px;margin-left: 280px;" @click="fanhui" >返回</el-button>
			 </div>
		 </div>
	</div>
</template>

<script>
    import purBtn from '@/components/btn.vue'
    import weitap from '@/components/weitap'
    export default {
        components: {
            purBtn,
            weitap
        },
        data() {
            return {
                shuju: [
                    {lian: 'huiyuan', neir: '会员列表'},
                    {lian: 'huiyuanxin', neir: '新增会员'},
                    {lian: 'huiyuanqianxin', neir: '签约续约'}
                ],
                Tapchecked: 2,
                infant_arr: [{
                    user_id: '',
                    baobao_name: '',
                    baobao_name2: '',
                    baobao_sex: '',
                    baobao_birthday: ''
                }],
                dialogVisibl2:false,
				heid:'',
				he_name:'',//合同名称
				compact:'',//合同编号
				droit_e:'',//权利说明
				payment_e:'',//付款说明
				clause_name:'',//背面协议
				ckbox_name:'否',
                jl_id:'',
                value1: '',
                value2: '',
                ul_show: '',
                radio: '男',//性别
                infant_name: '',//幼儿姓名
                pay_list: [
                    {name: '现金'},
                    {name: '微信'},
                    {name: '支付宝'},
                    {name: '银行卡'},
                ],//支付方式
                y_list: [],//优惠券
                class_list: [],//课时包
                name_list: [],//姓名
                vip: '',//会员卡号
                dindan:'',  //收据号
                centre_list: '',//中心
                parent_list: '',//父母资料
                s_id: '',//价格
                y_id: '',//优惠
                give_class: 0,//赠送课时
                receipt_type:'',//付款方式
                total: '',//合计
                price_list: '',//课时节数
                pitch: '',//节数
                y_price: '',//优惠价格
                f_price: '',//应付
                s_price: '',//实付
                bz:'',  //备注
                dialogVisible: false,
                search_type: [],
                goods: [],
                currentPage3: 1,//默认页
                table_list: [],//列表数据
                page_total: 0,//分页数据
                num1: 0,//计数器
                search_id: '',//搜索类型
                search_val: '',//搜索内容
                now_name_index:'',
                is_vip:false,
                nowpage:1,
                token:'',
                need_uid:'',
				page_b:true,
				check_mull:2
            }
        },
        mounted(){
            let self = this;

            self.token = $.cookie('token');
			self.heid=self.$route.query.he_id
			console.log(self.heid)
			this.gain()
        },
        methods: {
			// 获取合同名称
			gain:function(){
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/Contract/contract_see",
					data: {
						token: self.token,
						item_id:self.heid,
					},
					success: function(data) {
						self.he_name=data.data.name
						self.check_mull=data.data.check
						if(data.data.check==1){
							self.droit_e=data.data.contract.part1
							self.payment_e=data.data.contract.part2
							self.clause_name=data.data.contract.part3
						}else{
							self.droit_e=''
							self.payment_e=''
							self.clause_name=''
						}
					},
					error: function(data) {
						self.$message.error(`请求失败!`);
					}
				});
			},
			ckbox_but(e){
				var checked=e.target.checked
				if(checked){
					this.ckbox_name="是"
				}else{
					this.ckbox_name="否"
				}
			},
			fanhui(){this.page_b=true},
			add_a(){
				let that = this
				if(that.droit_e.length == 0){
				    that.$message({
				        message: '请填写权利说明 ',
				        type: 'error'
				    });
				    return false;
				}
				if(that.payment_e.length == 0){
				    that.$message({
				        message: '请填写付款说明 ',
				        type: 'error'
				    });
				    return false;
				}
				this.page_b=false

			},
            add_con(){
                let that = this
                if(that.clause_name.length == 0){
                    that.$message({
                        message: '请填写条款协议',
                        type: 'error'
                    });
                    return false;
                }
                const loading = that.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                $.ajax({
                    url: process.env.apiUrl + 'saas/Contract/add_contract',
                    type: 'post',
                    data: {
                        'token':that.token,
						 item_id:that.heid,
						 item_name:that.he_name,
						 part1:that.droit_e,
						 part2:that.payment_e,
						 part3:that.clause_name,

                    },
                    success: function (data) {
                        if(data.status == 1){
							loading.close();
                            that.$message({
                                message: data.msg,
                                type: 'success'
                            });
							setTimeout(function(){
								that.$router.push({name:"xinjianheyue",});
							},1000);
                        }else{
                            that.$message({
                                message: data.msg,
                                type: 'error'
                            });
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },

        },
        watch: {
        }

    }
</script>

<style scoped>
	.el-dialog__body{
		padding: 0;
	}
    * {
        font-size: 12px;
        margin: 0;
        padding: 0;
    }

    [v-cloak] {
        display: none;
    }
	input[disabled],textarea[disabled]{background: #fff;}
	input,textarea,select,a,button:focus {outline: none;}
    .head {
        padding: 10px 45px 0;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        border-bottom: 1px solid #bdb8e0;
    }
    li {
        list-style: none;
    }

    body {
        margin: 30px 40px;
    }
	.back_box{
        width: 210mm;
        height: 294mm;
        padding: 15px 30px;
        box-sizing: border-box;
	}
	.back_box textarea{
		width: 100%;
		height:90%;
	}
    #wrap {
        width: 210mm;
        height: 294mm;
        padding: 15px 30px;
        box-sizing: border-box;
    }

    .header .title {
        font-size: 18px;
        font-weight: bold;
    }
	.header .hename {
        border: 0;
        border-bottom: 1px solid;
        outline: none;
        padding-left: 11px;
        min-width: 50px;
    }
    .header .right {
        display: inline-block;
        font-weight: bold;
        font-size: 18px;
        float: right;
    }
    .small-title span {
        display: inline-block;
        margin-top: 58px;
        margin-left: 5px;
        margin-bottom: 14px;
    }

    .small-title ul {
        float: right;
        margin-right: 3px;
    }

    .small-title input {
        border: 0;
        border-bottom: 1px solid;
        outline: none;
        padding-left: 11px;
        width: 100px;
    }

    .information {
        margin-left: 6px;
    }

    .information ul {
        width: 49%;
        display: inline-block;
    }

    .information li {
        margin-top: 9px;
    }

    .information input{
        border: 0;
        border-bottom: 1px solid;
        outline: none;
        padding-left: 11px;
        width: 255px;
    }
    .s_pinput {
        border: 0;
        border-bottom: 1px solid;
        outline: none;

        width: 155px;
    }

    .information li span {
        letter-spacing: 2px;
    }

    .infant {
        margin-left: 5px;
    }

    .infant .n_input {
        border: 0;
        border-bottom: 1px solid;
        outline: none;
        padding-left: 11px;
        width: 60px;
    }

    .infant .t_input {
        border: 0;
        border-bottom: 1px solid;
        outline: none;
        padding-left: 11px;
        width: 30px;
    }

    .infant .add {
        display: inline-block;
        width: 14px;
        height: 14px;
        line-height: 13px;
        text-align: center;
        border: 1px solid black;
        border-radius: 50%;
        cursor: pointer;
    }

    .infant label {
        margin-left: 25px;
    }

    .infant input {
        vertical-align: middle;
    }

    .infant .title {
        margin: 13px 0 5px 0;
        font-weight: bold;
    }

    .ul_list {
        position: absolute;
        background-color: rgb(255, 255, 255);
        z-index: 999;
        border: 1px solid gray;
        padding: 3px 10px 8px;
        width: 160px;
        text-align: center;
        margin-top: 5px;
        margin-left: 40px;
    }

    .ul_list li span {
        float: left;
        cursor: pointer;
        width: 50%;
        margin-top: 5px;
    }

    .content {
        margin-left: 5px;
    }

    .content .line {
        margin-top: 5px;
    }

    .content .title {
        font-weight: bold;
        margin-top: 15px;
        margin-bottom: 5px;
    }

    .content table {
        width: 100%;
    }

    .content .one-table td {
        text-align: center;
    }

    .one-table .tr td {
        width: 16%;
        padding: 8px 0;
    }

    .content .sel {
        margin-top: 10px;
        padding-left: 5px;
        padding-right: 30px;
    }

    .content .two-table div {
        padding: 10px 0 10px 15px;
        border-top: 1px solid black;
    }

    .content .two-table textarea {
        margin-left: 14px;
        width: 92%;
        height: 58px;
        margin-top: 24px;
        padding: 6px 10px;
        box-sizing: border-box;
        outline: none;
    }

    .content div:first-child {
        border: 0;
    }

    .three-table td, th {
        text-align: center;
        padding: 8px 0;
    }
    .close_btn{
        margin-left: 11px;
        position: relative;
        border: 1px solid gray;
        border-radius: 2px;
        padding: 4px 15px 4px 5px;
    }
    .close_btn span{
        position: absolute;
        top: 0;
        right: 3px;
        cursor: pointer;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 130px;
    }

    .el-input--prefix .el-input__inner {
        border-color: gainsboro;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: gainsboro;
        background: gray;
    }

    .el-radio__input.is-checked + .el-radio__label {
        color: black;
    }

    .el-dialog__body {
        position: relative;
        padding: 0;
    }

    .el-dialog__header {
        display: none;
    }

    .dia_header {
        padding: 12px 12px 12px 30px;
        background-color: gainsboro;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        position: relative;
    }

    .search_inp {
        height: 24px;
        margin-left: 30px;
        padding-left: 10px;
        outline: none;
        border: 1px solid gray;
        border-radius: 2px;
        margin-right: 5px;
    }

    .search_sel {
        height: 26px;
        padding-right: 10px;
        padding-left: 5px;
    }

    .el-input-number--mini {
        width: 100px;
    }

    .el_close {
        color: rgb(255, 255, 255);
        font-size: 24px;
        float: right;
        padding-right: 18px;
        cursor: pointer;
    }

    .el-button {
        padding: 6px 10px;
    }

    .el-button:active {
        color: gray;
        border-color: grey;
    }

    .el-button:hover {
        color: gray;
        border-color: grey;
        background-color: gainsboro;
    }

    .el-pager li.active {
        color: gray;
    }

    .el-pager li:hover {
        color: gray;
    }

    .input_num {
        width: 60px;
        height: 23px;
        text-align: center;
        border: 1px solid grey;
        border-radius: 3px;
    }

    .el-table td, .el-table th {
        padding: 6px 0;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: gainsboro;
        border-color: gray;
    }
    input[]:invalid, input:focus:invalid, textarea[]:invalid, textarea:focus:invalid{box-shadow: none;}
    .huiTap{
        width: 100%;
        padding-left: 32px;
        padding-right: 54px;
        height: 50px;
        border-bottom: 1px solid #dbdbdb;
    }
    .huiList{
        padding-top:10px;
        width: 500px;
        float: left;
    }
    .huiList li{
        width:93px ;
        height: 39px;
        line-height: 39px;
        float: left;
        text-align: center;
        overflow: hidden;
        border-top: 1px solid #8CBB77;
        border-left: 1px solid #8CBB77;
        border-right: 1px solid #8CBB77;
        border-radius: 8px 8px 0 0;
        margin-right:15px;

    }
    .huiList li a{
        display: block;
        width: 100%;
        height: 100%;
        background:#8CBB77;
        color: #fff;
    }
    .huiList li a.active{
        background:#edebff;
        color: #8CBB77;
    }
    .el-input__prefix{display:none}
    .el-input--prefix .el-input__inner{padding-left:0}
</style>



// WEBPACK FOOTER //
// src/pages/xitong/xinjianhetong.vue